import { render, staticRenderFns } from "./PotentialReach.vue?vue&type=template&id=361180f3&scoped=true&"
import script from "./PotentialReach.vue?vue&type=script&lang=js&"
export * from "./PotentialReach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361180f3",
  null
  
)

export default component.exports